export function storeUser(user) {
  return {
    type: "STORE_USER",
    payload: user,
    access_token: user?.access_token,
    id_token: user?.id_token,
  }
}

export function storeUserError() {
  return {
    type: "STORE_USER_ERROR",
  }
}
